import axios from "axios";
import {
    url_pattern_activities,
    url_pattern_activities_active,
    url_pattern_activity,
    url_pattern_activity_status,
} from "../url";

export default function DB_PatternActivity (token) {
    const formData = new FormData;
    formData.append('token', token);

    const appendToken = (data) => {
        const fd = new FormData;
        for (const pair of data.entries()) {
            fd.append(pair[0], pair[1]);
        }
        fd.append('token', token);
        return fd
    }



    const getPatternActivities = () => {
        return axios.post(url_pattern_activities, formData)
    }

    const getActivePatternActivities = () => {
        return axios.post(url_pattern_activities_active, formData)
    }

    const getPatternActivity = (id) => {
        return axios.post(url_pattern_activity + id, formData)
    }


    const createPatternActivity = (data) => {
        return axios.post(url_pattern_activity, appendToken(data))
    }


    const updatePatternActivity = (data) => {
        return axios.put(url_pattern_activity, appendToken(data))
    }


    const statusPatternActivity = (data) => {
        return axios.post(url_pattern_activity_status, appendToken(data))
    }



    return {
        getPatternActivities,
        getPatternActivity,
        createPatternActivity,
        updatePatternActivity,
        statusPatternActivity,
        getActivePatternActivities,
    }
}
